import { render, staticRenderFns } from "./ClaimPointDialog.vue?vue&type=template&id=967fc41e"
import script from "./ClaimPointDialog.vue?vue&type=script&lang=js"
export * from "./ClaimPointDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports